import { IOption } from '@cp/src/components/AutocompleteDropdown/interfaces';
import { Typography } from '@navi/web-ui/lib/primitives';

type CustomOptionProps = {
  option: IOption;
  styles: CSSModuleClasses;
  name: string;
};

const CustomOption = (props: CustomOptionProps) => {
  const { name, option, styles } = props;
  if (['primaryRegion', 'secondaryRegion', 'tertiaryRegion'].includes(name)) {
    return (
      <div>
        <Typography variant="p3">{option.label}</Typography>
        <Typography variant="p5" color="var(--navi-color-gray-c2)">
          {option?.additionalData?.state?.join(', ')}
        </Typography>
      </div>
    );
  } else if (name === 'reportingManagerEmailAddress') {
    return (
      <div>
        <Typography variant="p3">{option?.additionalData?.name}</Typography>
        <Typography variant="p5" color="var(--navi-color-gray-c2)">
          {option?.additionalData?.emailAddress} | {option?.additionalData?.phoneNumber}
        </Typography>
      </div>
    );
  } else {
    return (
      <div className={styles.optionLabel}>
        <Typography variant="p3">{option.label}</Typography>
      </div>
    );
  }
};

export default CustomOption;
